import React, { Component, Fragment } from 'react';
import BookStoreSideBar from './book-side-bar';
import BookStoreContent from './book-content';

class BookStore extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			ready: false, showFilters: false, isMobile: false
		};
	}
 
	toggleFilters() {
		this.setState( ( prevState ) => {
			const newShowFilters = !prevState.showFilters;

			// Toggle body scroll based on the state
			if ( newShowFilters ) {
				document.body.classList.add( 'no-scroll' );
			} else {
				document.body.classList.remove( 'no-scroll' );
			}

			return { showFilters: newShowFilters };
		} );
	}

	componentDidMount() {
		this.handleResize();
		window.addEventListener( 'resize', this.handleResize.bind( this ) );
	}

	componentWillUnmount() {
		window.removeEventListener( 'resize', this.handleResize.bind( this ) );
	}

	handleResize() {
		//IF UPDATING SIZE HERE, UPDATE IN _CATEGORY-ARCHIVE.SCSS AS WELL.
		const isMobile = window.innerWidth <= 992;

		if ( !isMobile && this.state.showFilters ) {
			this.setState( { showFilters: false } );
			document.body.classList.remove( 'no-scroll' );
		} else {
			this.setState( { isMobile } );
		}
	}



	render() {


		return (
		<div>
			<div class="blue-hero-side-bar-bookstore">
			<div class="container">
				    <div class="decoy-side-bar side-bar-container"></div>
					<BookStoreSideBar /> 
					<div class="col-lg-9 bookstore-content">
						<div>
							<div class="blue-hero-title-wrap large">

					<h2 class="blue-hero-title">
						<span>Books</span>
					</h2>
					<div class="icon-chip">
						<span class="category-icon category-bookstore" aria-hidden="true"></span>
					</div>
					</div>
				</div>
			</div>
		</div>
		</div>

			<div class="site-content container">
<div class="decoy-side-bar"></div>
<div class="col-lg-3 bookstore-sidebar">
</div>
<div class="col-lg-9 bookstore-content">
	<BookStoreContent />

</div>
</div>
	</div>
		);
	}
}


export default BookStore; // Wrap with withRouter
